import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HomeNews from './components/HomeNews';

const homesNews = (props,{ t }) => (
  <Container>
    <HomeNews {...props} />
  </Container>
);

homesNews.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(homesNews);
